export default [
    {
        path: '/database/football/data',
        name: 'data',
        component: () => import("../views/database/football/data.vue")
    }
]
